import React from 'react';
import { Button } from './ui/button';
import { Shield, CheckCircle, Users, Award } from 'lucide-react';
import { heroData } from '../data/mock';

const Hero = ({ onContactClick }) => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.image}
          alt="Professional trademark registration services"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1e3a5f]/95 via-[#1e3a5f]/90 to-[#2d8b8b]/85"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          {/* Trust Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-2 mb-6">
            <Award className="w-4 h-4 text-[#2d8b8b]" />
            <span className="text-sm text-white font-medium">USPTO Filing Experts • 1000+ Trademarks Filed</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {heroData.title}
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-gray-100 mb-8 leading-relaxed max-w-2xl">
            {heroData.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button
              onClick={onContactClick}
              size="lg"
              className="bg-[#2d8b8b] hover:bg-[#236b6b] text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              {heroData.ctaText}
            </Button>
            <Button
              onClick={onContactClick}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-md border-2 border-white text-white hover:bg-white hover:text-[#1e3a5f] text-lg px-8 py-6 transition-all duration-300"
            >
              {heroData.secondaryCta}
            </Button>
          </div>

          {/* Feature Pills */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg px-4 py-3">
              <div className="w-10 h-10 bg-[#2d8b8b] rounded-full flex items-center justify-center flex-shrink-0">
                <Shield className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">95% Success Rate</p>
                <p className="text-gray-200 text-xs">USPTO Approved</p>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg px-4 py-3">
              <div className="w-10 h-10 bg-[#2d8b8b] rounded-full flex items-center justify-center flex-shrink-0">
                <CheckCircle className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Fast Processing</p>
                <p className="text-gray-200 text-xs">24hr Response</p>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg px-4 py-3">
              <div className="w-10 h-10 bg-[#2d8b8b] rounded-full flex items-center justify-center flex-shrink-0">
                <Users className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Expert Team</p>
                <p className="text-gray-200 text-xs">10+ Years</p>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg px-4 py-3">
              <div className="w-10 h-10 bg-[#2d8b8b] rounded-full flex items-center justify-center flex-shrink-0">
                <Award className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Best Price</p>
                <p className="text-gray-200 text-xs">From $45</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
